import { Component, inject, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { OAuthService } from "angular-oauth2-oidc";
import { NgxSpinnerModule, NgxSpinnerService } from "ngx-spinner";
import { ToastrService } from "ngx-toastr";
import { authConfig } from "src/app/shared/auth/models/auth.config";
import { AuthService } from "src/app/shared/auth/services/auth.service";
import { GoogleAnalyticsService } from "src/app/shared/services/google-analytics.service";

@Component({
    templateUrl: './logout.component.html',
    standalone: true,
    imports:[NgxSpinnerModule]
})

export class LogoutComponent implements OnInit {
  private error: string;
  route = inject(ActivatedRoute);
  router = inject(Router);
  toastr = inject(ToastrService);
  oauthService = inject(OAuthService);
  authService = inject(AuthService);
  spinnerService = inject(NgxSpinnerService);
  gaService = inject(GoogleAnalyticsService);


  constructor() {
    this.error = this.route.snapshot.queryParams.error;
    this.configure();
  }

  private configure() {
    this.oauthService.configure(authConfig);
  }

  public async ngOnInit() {
    this.spinnerService.show();

    if(this.error != null && this.error != undefined && this.error != '') {
      this.toastr.error(this.error);
      this.spinnerService.hide();
      return;
    }

    this.authService.cleanStorageGovBr();
    this.authService.cleanStorageMasp();
    this.authService.cleanStorageConviva();
    this.gaService.clearUserId();

    setTimeout(() => {
      this.router.navigate(['/login']);
      this.spinnerService.hide();
    }, 5000);
  }
}
